import { IDemonstrativeMovement } from "src/@types/store-conciliation";

import { DemonstrativeGroup, GroupDivergence, NO_DIVERGENCE } from "./types";

const CENTS_PER_UNIT = 100;

export const toCents = (amount: number): number =>
  Math.round(amount * CENTS_PER_UNIT);

export const divergenceOf = (
  group: DemonstrativeGroup,
  movements: readonly IDemonstrativeMovement[],
): GroupDivergence => {
  if (!group.comparable || movements.length !== 2) return NO_DIVERGENCE;

  const [first, second] = movements;

  return {
    amount: toCents(first.amount) !== toCents(second.amount),
    quantity: first.quantity !== second.quantity,
  };
};
